import { render } from "./DeleteReferenceProfile.vue?vue&type=template&id=758a3a78&scoped=true"
import script from "./DeleteReferenceProfile.vue?vue&type=script&lang=js"
export * from "./DeleteReferenceProfile.vue?vue&type=script&lang=js"

import "./DeleteReferenceProfile.vue?vue&type=style&index=0&id=758a3a78&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-758a3a78"]])

export default __exports__